import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    count = 0;
    private readonly loading = signal(false);
    /** Read-only loading state as a signal (replaces the legacy RxJS Subject). */
    public readonly isLoading = this.loading.asReadonly();

    constructor() { }

    show() {
        this.count++;
        if (this.count > 0) { this.loading.set(true); }
    }

    hide() {
        if (this.count > 0) { this.count--; }
        if (this.count === 0) { this.loading.set(false); }
    }

}
